export default __webpack_public_path__ + "static/media/post2.a76ae1a9.jpg";